import React, { FunctionComponent } from 'react';

import { Router, StaticRouter } from 'react-router-dom';

import { history } from '../../helpers/navigation';
import { User } from '../user';
import RootContainer from './root-container';

export interface Props {
    location: string;
    user: User | null;
}

const Root: FunctionComponent<Props> = ({ location }) => {
    if (NODE) {
        return (
            <StaticRouter location={location}>
                <RootContainer />
            </StaticRouter>
        );
    }
    return (
        <Router history={history}>
            <RootContainer />
        </Router>
    );
};

export default Root;
